import * as palette from "@govlaunch/palette";
import React, { ReactNode } from "react";

interface IStickyFooterProps {
  children: ReactNode;
}

export default function StickyFooter({ children, ...props }: IStickyFooterProps) {
  return (
    <div
      css={{
        position: "sticky",
        bottom: 0,
        background: palette.white,
        border: `solid 1px ${palette.lightestGray}`,
        borderRadius: 5,
        zIndex: 999,
      }}
      {...props}
    >
      {children}
    </div>
  );
}
